import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Bug, Book } from "lucide-react";
import HeadingPage from "~/molecules/HeadingPage";
import { Button } from "~/atoms/button";

const supportMail = "support@northhouse.se";

export default function Support() {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const mailtoHref =
    language === "sv"
      ? `mailto:${supportMail}?subject=Felrapport&body=Beskriv%20gärna%20felet%20du%20stött%20på.%20Bifoga%20skärmdumpar%20om%20möjligt.`
      : `mailto:${supportMail}?subject=Bug%20report&body=Please%20describe%20the%20bug%20you%20encountered.%20Include%20screenshots%20if%20possible.`;

  return (
    <div className="container space-y-4 py-7">
      <div>
        <HeadingPage title={t("commons.support.pageTitle")} />
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <div className="flex flex-col justify-between gap-6 rounded-lg border bg-white p-6 shadow-md">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <Bug className="text-destructive h-6 w-6" />
              <h2 className="text-2xl font-semibold">
                {t("commons.support.contactSupport")}
              </h2>
            </div>
            <p className="text-muted-foreground">
              {t("commons.support.contactDescription")}
            </p>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-sm">{t("commons.support.emailUs")}:</p>
            <a
              className="text-primary inline-block text-lg font-medium hover:underline"
              href={mailtoHref}
            >
              {supportMail}
            </a>
          </div>
        </div>

        <div className="flex flex-col justify-between gap-6 rounded-lg border bg-white p-6 shadow-md">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <Book className="text-primary h-6 w-6" />
              <h2 className="text-2xl font-semibold">
                {t("commons.support.userGuide")}
              </h2>
            </div>
            <p className="text-muted-foreground">
              {t("commons.support.userGuideDescription")}
            </p>
          </div>
          <div>
            <Link to="/user-guide">
              <Button className="w-full md:w-auto">
                {t("commons.support.viewGuide")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
